import { render, staticRenderFns } from "./TopUp.vue?vue&type=template&id=80df19dc&scoped=true"
import script from "./TopUp.vue?vue&type=script&lang=js"
export * from "./TopUp.vue?vue&type=script&lang=js"
import style0 from "./TopUp.vue?vue&type=style&index=0&id=80df19dc&prod&scoped=true&lang=css"
import style1 from "./TopUp.vue?vue&type=style&index=1&id=80df19dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80df19dc",
  null
  
)

export default component.exports